import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=2a2d03e3"
import script from "./InfoRow.vue?vue&type=script&lang=js"
export * from "./InfoRow.vue?vue&type=script&lang=js"
import style0 from "./InfoRow.vue?vue&type=style&index=0&id=2a2d03e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports